let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bC8D6")).then(() => parcelRequire('boRYE'));